<template>
  <div class="wps-template-detail">
    <p>
      温馨提示：模板领取后保存在WPS云文档中
    </p>
    <div class="main"  v-pullUp="loadMore">
      <Head>{{parentName}}</Head>
      <Item class="item" v-for="(item, index) in totalLists"
            v-if="item.size/1024 < 10"
            :key="index"
            :item="item"
            :fileName="item.name"
            :size="item.size"
            :lastModified="item.lastModified" @toPage="toPage"></Item>
      <list-end-line :text="'到底了哦~'" :isEnd="isEnd"/>
    </div>
  </div>
</template>

<script>
import keys from 'lodash.keys'
import module from '../../modules/WpsTemplate/detail'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import Head from '../../components/WpsTemplate/Head'
import Item from '../../components/WpsTemplate/Item'
import ListEndLine from '../../components/ListEndLine'
import api from '@edu-fe/api'

export default {
  computed: {
    ...mapState(module.name, keys(module.state)),
    ...mapGetters(module.name, keys(module.getters))
  },
  methods: {
    ...mapMutations(module.name, keys(module.mutations)),
    ...mapActions(module.name, keys(module.actions)),
    async toPage (fileId) {
      this.$loading.show()
      const { data } = await api.wpsTemplate.addFile(fileId)()
      this.$loading.hide()
      if (data) {
        window.location.href = data
      }
    },
    async loadMore () {
      if (!this.loading && this.currentPageNo <= this.totalPage) {
        this.$loading.show()
        await this.getList()
        this.$loading.hide()
      }
    }
  },
  directives: {
    pullUp: {
      bind (el, binding) {
        el.fn = () => {
          const scrollTop = el.scrollTop
          const scrollHeight = el.scrollHeight
          const clientHeight = document.documentElement.clientHeight
          if (scrollTop + clientHeight + 50 > scrollHeight) {
            binding.value()
          }
        }
        el.addEventListener('scroll', el.fn)
      },
      unbind (el) {
        el.removeEventListener('scroll', el.fn)
      }
    }
  },
  beforeCreate () {
    this.$store.registerModule(module.name, module)
  },
  mounted () {

  },
  created () {
    this.init()
  },
  beforeDestroy () {
    this.resetData()
    this.$store.unregisterModule(module.name)
  },
  components: {
    Head,
    Item,
    ListEndLine
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.wps-template-detail {
  height: 100vh;
  overflow: scroll;
  > p {
    font-size: rem(24);
    color: #C19671;
    background-color: #FFF7EB;
    text-align: center;
    height: rem(60);
    line-height: rem(60);
  }
  .main {
    background-color: #fff;
    height: 100%;
    overflow: scroll;
  }
  .item {
    &:last-child {
      border: none;
    }
  }
}
</style>
